import React from 'react';

import PropTypes from 'prop-types';

import { SkeletonLine } from '~/techstyle-shared/react-components';

const ProductCardPricing = ({ final }) => {
  // TODO: change this to loading status
  if (!final) {
    return <SkeletonLine width="100%" height="20px" />;
  }
  // TODO: Add currency formatting
  // TODO: Add retail vs default (vip) UI pricing, strike through, etc.
  // TODO: Add promo pricing/labels
  // TODO: [Nice to Have] update related images api to fetch pricing data
  return <div style={{ fontWeight: 'bold' }}>${final}</div>;
};

ProductCardPricing.propTypes = {
  final: PropTypes.string,
};

export default ProductCardPricing;
